import { Controller } from "@hotwired/stimulus"

// Makes a div clickable, supporting regular click (same tab) and cmd+click/ctrl+click (new tab).
// Usage:
// <div
//   data-controller="linkable"
//   data-linkable-url-value="/path/to/page"
//   class="cursor-pointer">
//   <!-- Content -->
// </div>
export default class extends Controller {
  static values = {
    url: String,
  }

  connect() {
    if (!this.hasUrlValue) {
      this.urlValue = this.element.getAttribute("href")
    }

    this.element.setAttribute("role", "link")
    this.element.setAttribute("tabindex", "0")
    this.element.addEventListener("click", this.click.bind(this))
    this.element.addEventListener("keydown", this.keydown.bind(this))
  }

  click(event) {
    // Don't navigate if clicking on a link or button
    if (this.isInteractiveElement(event.target)) {
      return
    }

    // Check for modifier keys (cmd on Mac, ctrl on Windows/Linux)
    if (event.metaKey || event.ctrlKey) {
      window.open(this.urlValue, "_blank")
    } else {
      Turbo.visit(this.urlValue)
    }
  }

  keydown(event) {
    // Allow Enter key to navigate
    if (event.key === "Enter") {
      event.preventDefault()
      Turbo.visit(this.urlValue)
    }
  }

  isInteractiveElement(element) {
    // Check if the clicked element or its parent is a link, button, or has data-linkable-ignore
    const interactiveSelectors = ["a", "button", "[data-linkable-ignore]"]
    return interactiveSelectors.some((selector) => element.closest(selector))
  }
}

